var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlide3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 249.993,
    height: 176.654,
    viewBox: "0 0 249.993 176.654",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "slide3",
    transform: "translate(-57.982 -67.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(57.982 67.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M486.81,601.69l-5.349-2.252-3.669-26.814H428.927l-3.977,26.7-4.785,2.393a1.136,1.136,0,0,0,.508,2.153h65.7a1.136,1.136,0,0,0,.44-2.184Z",
    transform: "translate(-328.647 -427.219)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M502.711,536.466H262.226c-2.627,0-4.754-1.463-4.754-3.26V510H507.465v23.206C507.465,535,505.338,536.462,502.711,536.466Z",
    transform: "translate(-257.472 -375.437)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M507.073,420.041H257.08V275.213a5.739,5.739,0,0,1,5.733-5.733H501.34a5.739,5.739,0,0,1,5.733,5.733Z",
    transform: "translate(-257.08 -269.48)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M515.2,433.811H280.579a4.848,4.848,0,0,1-4.711-4.965V293.234a4.849,4.849,0,0,1,4.711-4.966H515.2a4.849,4.849,0,0,1,4.711,4.966V428.845a4.848,4.848,0,0,1-4.711,4.966Z",
    transform: "translate(-272.895 -285.906)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(31.813 23.759)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_182",
    "data-name": "Ellipse 182",
    cx: 0.982,
    cy: 0.982,
    r: 0.982,
    transform: "translate(20.027 11.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_183",
    "data-name": "Ellipse 183",
    cx: 0.982,
    cy: 0.982,
    r: 0.982,
    transform: "translate(23.756 11.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_184",
    "data-name": "Ellipse 184",
    cx: 0.982,
    cy: 0.982,
    r: 0.982,
    transform: "translate(27.485 11.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    width: 124.761,
    height: 0.693,
    transform: "translate(18.623 14.936)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_246",
    "data-name": "Rectangle 246",
    width: 143.429,
    height: 91.858,
    transform: "translate(0.061 0.081)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    width: 143.429,
    height: 6.093,
    fill: "#00b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    width: 135.227,
    height: 35.017,
    transform: "translate(4.281 11.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_259",
    "data-name": "Rectangle 259",
    width: 135.227,
    height: 35.017,
    transform: "translate(4.367 51.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(49.945 18.755)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    width: 73.185,
    height: 3.262,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 26.094,
    height: 3.262,
    transform: "translate(0 8.154)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_252",
    "data-name": "Rectangle 252",
    width: 51.984,
    height: 3.262,
    transform: "translate(0 16.309)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M299.665,427.326a12.165,12.165,0,0,1-1.989,6.685,11.883,11.883,0,0,1-.895,1.2,12.285,12.285,0,0,1-2.621,2.329q-.4.265-.823.5a12.126,12.126,0,0,1-4.751,1.463c-.379.037-.765.055-1.153.055a12.18,12.18,0,0,1-3.156-.413,11.718,11.718,0,0,1-1.707-.593q-.424-.183-.829-.4a12.042,12.042,0,0,1-1.842-1.193q-.4-.313-.776-.66a12.23,12.23,0,1,1,20.543-8.973Z",
    transform: "translate(-255.224 -358.217)",
    fill: "#00b9ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(26.502 63.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_273",
    "data-name": "Rectangle 273",
    width: 1.499,
    height: 11.416,
    transform: "translate(4.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    width: 11.416,
    height: 1.499,
    transform: "translate(0 4.958)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(48.11 59.526)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_250-2",
    "data-name": "Rectangle 250-2",
    width: 73.185,
    height: 3.262,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251-2",
    "data-name": "Rectangle 251-2",
    width: 26.094,
    height: 3.262,
    transform: "translate(0 8.154)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_252-2",
    "data-name": "Rectangle 252-2",
    width: 51.984,
    height: 3.262,
    transform: "translate(0 16.309)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    cx: 1.008,
    cy: 1.008,
    r: 1.008,
    transform: "translate(8.478 2.023)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_195",
    "data-name": "Ellipse 195",
    cx: 1.008,
    cy: 1.008,
    r: 1.008,
    transform: "translate(12.304 2.023)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_246",
    "data-name": "Ellipse 246",
    cx: 1.008,
    cy: 1.008,
    r: 1.008,
    transform: "translate(4.642 2.023)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M317.271,320.413a20.9,20.9,0,0,0-3.335-1.4l-.147-1.622-5.948-.641-.756,2.074-2.135.8a1.037,1.037,0,0,0-.217.113h0a1.057,1.057,0,0,0-.451.7,1.08,1.08,0,0,0,.016.424l.113.463c.162.1.329.19.5.278l.106.054c.244.126.492.246.747.357l.16.068.011,0c.12.05.239.1.361.142a11.844,11.844,0,0,0,1.223.393,12.577,12.577,0,0,0,3.243.424c.4,0,.794-.018,1.185-.056a12.533,12.533,0,0,0,2.626-.53l.007,0a12.32,12.32,0,0,0,1.577-.625s.007,0,.009,0c.115-.054.226-.113.339-.169l.054-.027c.09-.047.181-.095.271-.144.226-.124.447-.255.666-.395.061-.036.12-.075.181-.115.086-.056.171-.115.255-.176Q317.61,320.6,317.271,320.413Z",
    transform: "translate(-277.728 -282.059)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M302.547,331.657l-.372-1.681H301.2l-.029,0h0a2.108,2.108,0,0,0-.979.338,2.171,2.171,0,0,0-.523.469c.289.219.589.422.9.616l.014.007c.088.054.178.108.268.16.162.1.329.19.5.278l.106.054c.244.126.492.246.747.356l.16.068.011,0c.12.05.239.1.361.142Z",
    transform: "translate(-274.167 -292.304)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 4.284,
    cy: 4.284,
    r: 4.284,
    transform: "translate(28.569 25.094)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M312.992,270.17a2.709,2.709,0,0,0,1.886.734,17.764,17.764,0,0,0,4.824-.394c.1.951-.169,1.975.39,2.757a12.8,12.8,0,0,0,.455-2.9,2.777,2.777,0,0,0-.161-1.243,1.143,1.143,0,0,0-.974-.718,2.441,2.441,0,0,1,1.089-.465l-1.36-.684.349-.359-2.463-.151.713-.453a15.466,15.466,0,0,0-3.24-.1,2.782,2.782,0,0,0-1.433.4,1.035,1.035,0,0,0-.389,1.3,1.881,1.881,0,0,0-1.434,1.137,3.037,3.037,0,0,0-.109,1.46,10.343,10.343,0,0,0,.542,2.3Z",
    transform: "translate(-283.016 -242.879)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M301.757,243.678a12.571,12.571,0,1,0-21.723,11.941c.113.142.23.284.35.422l.025.027a12.178,12.178,0,0,0,.936.966c.086.079.176.16.266.237.171.153.347.3.53.44.072.056.142.113.217.167.289.219.589.422.9.616l.014.007c.088.054.178.108.269.16.162.1.329.19.5.278l.106.054c.244.126.492.246.747.357l.16.068.011,0c.12.05.239.1.361.142a11.867,11.867,0,0,0,1.223.393,12.577,12.577,0,0,0,3.243.424c.4,0,.794-.018,1.185-.056a12.525,12.525,0,0,0,2.627-.53l.007,0a12.33,12.33,0,0,0,1.577-.625s.007,0,.009,0c.115-.054.226-.113.338-.169l.054-.027c.09-.047.181-.095.271-.144.226-.124.447-.255.666-.395.061-.036.12-.074.181-.115.086-.056.171-.115.255-.176.11-.077.221-.156.329-.237.034-.025.07-.05.1-.077a12.566,12.566,0,0,0,4.269-14.144Zm-4.684,13.6c-.074.059-.151.115-.228.167s-.149.111-.226.16-.131.093-.2.135l-.02.014c-.05.034-.1.065-.149.1q-.281.176-.569.338l-.061.034c-.086.047-.171.093-.257.138-.011.007-.025.011-.036.018l-.014.007c-.108.056-.219.111-.329.162a11.075,11.075,0,0,1-1.316.533c-.059.02-.117.041-.176.059a11.835,11.835,0,0,1-2.487.505c-.37.034-.745.052-1.122.052a11.72,11.72,0,0,1-3.066-.4,11.144,11.144,0,0,1-1.505-.51c-.025-.011-.052-.02-.077-.032s-.052-.02-.077-.032-.052-.023-.079-.036c-.212-.093-.422-.194-.627-.3l-.1-.052c-.251-.131-.5-.271-.736-.42-.07-.043-.142-.088-.21-.135l-.052-.034c-.16-.106-.32-.217-.476-.332-.106-.079-.212-.158-.316-.239-.174-.131-.341-.271-.5-.415-.086-.072-.169-.151-.25-.226a11.476,11.476,0,0,1-.907-.939c-.095-.108-.187-.217-.275-.329a.9.9,0,0,1-.056-.07,11.882,11.882,0,1,1,16.5,2.083Z",
    transform: "translate(-256.858 -218.945)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M775.848,511.038a12.571,12.571,0,1,0-21.723,11.941c.113.142.23.284.35.422l.025.027a12.218,12.218,0,0,0,.937.966c.086.079.176.16.266.237.172.154.348.3.53.44a12.4,12.4,0,0,0,1.115.783l.014.007c.25.156.505.3.765.438l.106.054c.244.126.492.246.747.357l.16.068.011,0a12.21,12.21,0,0,0,1.584.535,12.578,12.578,0,0,0,3.242.424c.4,0,.794-.018,1.185-.057a12.515,12.515,0,0,0,2.626-.53l.007,0a12.32,12.32,0,0,0,1.577-.625s.007,0,.009,0c.115-.054.226-.113.338-.169l.054-.027c.09-.048.181-.095.271-.144.226-.124.447-.255.666-.395.061-.036.12-.074.181-.115.2-.131.395-.271.584-.413.034-.025.07-.05.1-.077A12.567,12.567,0,0,0,775.848,511.038Z",
    transform: "translate(-623.971 -425.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_188",
    "data-name": "Ellipse 188",
    cx: 1.884,
    cy: 1.884,
    r: 1.884,
    transform: "translate(142.27 90.609)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M822.78,563.837a1.884,1.884,0,0,1,1.658,2.778,1.883,1.883,0,1,0-3.129-2.07,1.88,1.88,0,0,1,1.471-.709Z",
    transform: "translate(-678.101 -473.177)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_189",
    "data-name": "Ellipse 189",
    cx: 5.534,
    cy: 5.534,
    r: 5.534,
    transform: "translate(135.099 81.42)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M784.836,525.882a5.533,5.533,0,0,1,7.67-.58c-.045-.043-.09-.086-.137-.128a5.534,5.534,0,1,0-7.386,8.244l.032.028c.047.042.1.081.143.121a5.533,5.533,0,0,1-.322-7.685Z",
    transform: "translate(-648.546 -442.362)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_190",
    "data-name": "Ellipse 190",
    cx: 3.564,
    cy: 3.564,
    r: 3.564,
    transform: "translate(137.022 85.313)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M782.328,579.307v1.2c-.219.14-.44.271-.666.395-.09.05-.181.1-.271.144l-.054.027c-.113.056-.224.115-.339.169,0,0-.007,0-.009,0a12.308,12.308,0,0,1-1.577.625l-.007,0a12.538,12.538,0,0,1-2.627.53c-.39.039-.785.056-1.185.056a12.582,12.582,0,0,1-3.242-.424,12.228,12.228,0,0,1-1.584-.535l-.011,0-.16-.068c-.255-.111-.5-.23-.747-.357l-.106-.054c-.26-.138-.515-.282-.765-.438l-.013-.007a12.351,12.351,0,0,1-1.115-.783c-.183-.14-.359-.287-.53-.44-.09-.077-.18-.158-.266-.237a12.185,12.185,0,0,1-.937-.966,4.577,4.577,0,0,1,.172-.693l0,0a1.035,1.035,0,0,1,.047-.113.892.892,0,0,1,.043-.095,2.143,2.143,0,0,1,2.042-.984c.512-.023,1.079,0,1.677,0,.316,0,.643-.014.97-.043,2.065-.187,1.69-1.406,1.783-2.062.093-.636.666-.086.7-.05l0,0a7.28,7.28,0,0,0,3.746.657c.221-.027.442-.043.663-.05.582-.007.456.16.255.3a2.522,2.522,0,0,1-.3.172s-.093.564-.187,1.408c-.09.808,1.458,1.187,1.586,1.216a.014.014,0,0,0,.009,0,3.108,3.108,0,0,1,1.717.045h0A2.035,2.035,0,0,1,782.328,579.307Z",
    transform: "translate(-635.364 -481.143)",
    fill: "#00b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M778.457,587.7c0,.167,0,.327-.011.478,0,.09-.007.178-.011.262l-.011,0-.16-.068c-.255-.111-.5-.23-.747-.357l-.106-.054c-.26-.138-.514-.282-.765-.438.007-.079.018-.158.029-.237.025-.174.045-.35.059-.523a7.264,7.264,0,0,0-.643-3.556v0c-.045-.09-.072-.14-.072-.14a1.36,1.36,0,0,1,1.593,0,.563.563,0,0,1,.156.135C778.33,583.867,778.484,586.105,778.457,587.7Z",
    transform: "translate(-643.03 -488.09)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M826.134,593.083c-.009.253-.023.517-.038.785v0s-.007,0-.009,0a12.323,12.323,0,0,1-1.577.625l-.007,0-.025-.634,0-.083-.12-3.087a.518.518,0,0,1,.517-.542h1.144c.056,0,.1.115.124.323v0A19.561,19.561,0,0,1,826.134,593.083Z",
    transform: "translate(-680.46 -493.774)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M796.181,537.154v3.565h.825l1.05-1.126-.141,1.126h3.649l-.226-1.126.451,1.126h.582v-3.565Z",
    transform: "translate(-658.643 -452.732)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    cx: 0.281,
    cy: 0.516,
    rx: 0.281,
    ry: 0.516,
    transform: "translate(136.694 87.611)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_192",
    "data-name": "Ellipse 192",
    cx: 0.281,
    cy: 0.516,
    rx: 0.281,
    ry: 0.516,
    transform: "translate(143.916 87.611)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M835.509,596.145c-.19.142-.386.282-.584.413-.061.041-.12.079-.18.115-.219.14-.44.271-.666.395-.09.05-.18.1-.271.144v-2.487s.361.289.936.77l.226.192C835.136,595.827,835.317,595.981,835.509,596.145Z",
    transform: "translate(-687.779 -497.313)",
    fill: "#00b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M775.848,511.038a12.571,12.571,0,1,0-21.723,11.941c.113.142.23.284.35.422l.025.027a12.218,12.218,0,0,0,.937.966c.086.079.176.16.266.237.172.154.348.3.53.44a12.4,12.4,0,0,0,1.115.783l.014.007c.25.156.505.3.765.438l.106.054c.244.126.492.246.747.357l.16.068.011,0a12.21,12.21,0,0,0,1.584.535,12.578,12.578,0,0,0,3.242.424c.4,0,.794-.018,1.185-.057a12.515,12.515,0,0,0,2.626-.53l.007,0a12.32,12.32,0,0,0,1.577-.625s.007,0,.009,0c.115-.054.226-.113.338-.169l.054-.027c.09-.048.181-.095.271-.144.226-.124.447-.255.666-.395.061-.036.12-.074.181-.115.2-.131.395-.271.584-.413.034-.025.07-.05.1-.077A12.567,12.567,0,0,0,775.848,511.038Zm-4.685,13.6c-.074.059-.151.115-.228.167s-.149.111-.226.16-.131.092-.2.135-.113.074-.169.111q-.281.176-.569.338l-.061.034c-.086.048-.171.093-.257.138-.011.007-.025.011-.036.018l-.014.007c-.108.056-.219.111-.329.162a11.069,11.069,0,0,1-1.316.532c-.059.02-.117.041-.176.059A11.846,11.846,0,0,1,765.1,527c-.37.034-.745.052-1.122.052a11.722,11.722,0,0,1-3.067-.4,11.14,11.14,0,0,1-1.505-.51c-.052-.02-.1-.043-.153-.063-.027-.011-.052-.023-.079-.036-.212-.093-.422-.194-.627-.3l-.1-.052c-.25-.131-.5-.271-.736-.42-.088-.054-.176-.11-.262-.169-.271-.178-.535-.37-.792-.571-.174-.131-.341-.271-.5-.415-.086-.072-.169-.151-.25-.226a11.451,11.451,0,0,1-.907-.939c-.095-.108-.187-.217-.275-.329a.831.831,0,0,1-.056-.07,11.882,11.882,0,1,1,16.5,2.083Z",
    transform: "translate(-623.971 -425.975)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M846.045,501.612a2.269,2.269,0,0,0,1.191-3.269l5.271-6.1-4.155-.541-4.368,5.878a2.281,2.281,0,0,0,2.062,4.035Z",
    transform: "translate(-694.876 -417.534)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M974.505,502.476a2.269,2.269,0,0,0-.533-3.438l1.676-7.888-3.9,1.53-.993,7.256a2.281,2.281,0,0,0,3.752,2.541Z",
    transform: "translate(-793.626 -417.109)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M703.921,521.655h-2.766l-1.316-8.454h4.083Z",
    transform: "translate(-541.922 -397.398)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M763.921,521.655h-2.766l-1.316-8.454h4.083Z",
    transform: "translate(-588.382 -397.398)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M889.085,564.48l-3.916-.157a1.019,1.019,0,0,1-.974-1.046l1.1-36.189.072-.026c6.863-2.483,12.541-2.3,17.358.573l.054.032.661,35.247a1.015,1.015,0,0,1-1.015,1.035h-3.3a1.018,1.018,0,0,1-1-.82l-4.5-22.883a.338.338,0,0,0-.668.025l-2.829,23.316a1.021,1.021,0,0,1-1.008.893Z",
    transform: "translate(-726.796 -443.578)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 5.542,
    cy: 5.542,
    r: 5.542,
    transform: "translate(160.556 40.689)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M859.013,433.5a1.016,1.016,0,0,1-.472-.38l-1.071-1.6a1.019,1.019,0,0,1,.027-1.166l4.317-5.86,2.7-12.977a3.271,3.271,0,1,1,6.1,2.374l-1.278,8.259a10.464,10.464,0,0,1-3.616,6.418l-5.683,4.769a1.017,1.017,0,0,1-.8.227A1,1,0,0,1,859.013,433.5Z",
    transform: "translate(-705.971 -353.829)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M950.852,434.51a1.017,1.017,0,0,1-.605.026l-1.863-.5a1.019,1.019,0,0,1-.75-.893L947,425.9l-6.544-11.528a3.271,3.271,0,1,1,6.144-2.246l4.5,7.044a10.465,10.465,0,0,1,1.526,7.206l-1.115,7.335a1.015,1.015,0,0,1-.659.8Z",
    transform: "translate(-770.21 -354.25)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M887.269,400.96a9.437,9.437,0,0,1,7.568-3.06l.277.019h0a9.417,9.417,0,0,1,6.806,3.756,9.559,9.559,0,0,1,1.7,7.7,29.869,29.869,0,0,0,.789,15.316l1.487,4.617a1.015,1.015,0,0,1-.912,1.325l-7.6.409-1.945-3.36v3.464l-9.238.5-.055,0a1.016,1.016,0,0,1-1.012-1.1l1.044-12.948-1.31-8.794A9.5,9.5,0,0,1,887.269,400.96Z",
    transform: "translate(-727.233 -344.886)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M901.451,349.616c-.513.3-2.541.491-2.686-.083l0-.013a4.322,4.322,0,0,1,.012-1.291,1.618,1.618,0,0,0-.307-1.223c-.548-.591-1.523-.278-2.315-.427a1.955,1.955,0,0,1-1.521-2.088c.011-.09.029-.179.049-.269a1.506,1.506,0,0,0-1.563-1.824c-.8.046-1.665.288-2.327-.3a2.542,2.542,0,0,1-.412-2.3c.378-1.092,2.8-1.663,3.859-1.978a9.166,9.166,0,0,1,7.769,1.275,4.113,4.113,0,0,1,1.577,1.829,2,2,0,0,1-.495,2.239,4.137,4.137,0,0,1,.958,4.018C903.729,348.2,902.215,349.177,901.451,349.616Z",
    transform: "translate(-731.501 -298.094)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M846.629,735.427H798.566a.226.226,0,1,1,0-.451h48.063a.226.226,0,1,1,0,.451Z",
    transform: "translate(-660.315 -605.916)",
    fill: "#ccc"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide3);
export default __webpack_public_path__ + "static/media/slide3.6ee3dcee029bf3fae4a34c1f0f8177f2.svg";
export { ForwardRef as ReactComponent };